import { Dataset } from "../utils/types";

export const dataset2025: Dataset = [
  {
    id: 1,
    text: "1. KOLO: Vánoce",
    questions: [
      {
        id: 1,
        question: "Která ingredience rozhodně nepatří do bramborového salátu?",
        answers: [
          {
            id: 1,
            text: "Uzeniny (gothaj, salám, šunka...)",
            points: 39,
            score: 6,
          },
          { id: 2, text: "Kečup", points: 30, score: 5 },
          { id: 3, text: "Jablko", points: 15, score: 4 },
          { id: 4, text: "Ananas", points: 7, score: 3 },
          { id: 5, text: "Cibule", points: 6, score: 2 },
          { id: 6, text: "Hrášek", points: 6, score: 2 },
        ],
      },
      {
        id: 2,
        question: "Jakým konverzačním tématem spolehlivě zkazíte rodinný oběd?",
        answers: [
          {
            id: 1,
            text: "Politika",
            points: 77,
            score: 6,
          },
          { id: 2, text: "LGBTQ+, gender", points: 11, score: 5 },
          { id: 3, text: "Sex", points: 7, score: 4 },
          { id: 4, text: "Fekální téma", points: 5, score: 3 },
          { id: 5, text: "Válka (na Ukrajině)", points: 5, score: 2 },
          { id: 6, text: "Klimatická změna", points: 4, score: 1 },
          { id: 7, text: "Izrael / Palestina", points: 4, score: 1 },
        ],
      },
      {
        id: 3,
        question: "Pod vánočním stromkem opravdu nechcete najít…",
        answers: [
          { id: 1, points: 14, score: 6, text: "Zvíře (kočka, pes...)" },
          { id: 2, points: 11, score: 5, text: "Hovno" },
          { id: 3, points: 11, score: 5, text: "Mrtvolu" },
          { id: 4, points: 9, score: 4, text: "Erotické pomůcky" },
          { id: 5, points: 7, score: 3, text: "Ponožky" },
          { id: 6, points: 6, score: 2, text: "Měkký dárek" },
          {
            id: 7,
            points: 5,
            score: 1,
            text: "Dárek, který jsem někomu dříve daroval",
          },
          { id: 8, points: 5, score: 1, text: "Rozvodové papíry" },
        ],
      },
      {
        id: 4,
        question:
          "V kolika letech by měly děti zjistit, že Ježíšek/Santa dárky nenosí?",
        answers: [
          { id: 1, points: 28, score: 6, text: "10" },
          { id: 2, points: 25, score: 5, text: "6" },
          {
            id: 3,
            points: 17,
            score: 4,
            text: "0 / Nikdy by na něj neměly věřit",
          },
          {
            id: 4,
            points: 16,
            score: 3,
            text: "8",
          },
          {
            id: 5,
            points: 11,
            score: 2,
            text: "Nikdy",
          },
          {
            id: 6,
            points: 9,
            score: 1,
            text: "7",
          },
        ],
      },
      {
        id: 5,
        question: "Nejhorší vánoční tradice je…",
        answers: [
          {
            id: 1,
            points: 41,
            score: 6,
            text: "Kapr (vč. kádí, zabíjení, vany)",
          },
          { id: 2, points: 15, score: 5, text: "Půst a zlaté prasátko" },
          { id: 3, points: 11, score: 4, text: "Lití olova" },
          { id: 4, points: 10, score: 3, text: "Trávení času s rodinou" },
          { id: 5, points: 9, score: 2, text: "Zpívání koled" },
          { id: 6, points: 6, score: 1, text: "Nakupování, dávání dárků" },
          { id: 7, points: 5, score: 1, text: "Úklid" },
        ],
      },
    ],
  },
  {
    id: 2,
    text: "2. KOLO: Pohádky",
    questions: [
      {
        id: 6,
        question: "V pohádkách jsou vždycky tři…",
        answers: [
          { id: 1, points: 30, score: 6, text: "Bratři" },
          { id: 2, points: 24, score: 5, text: "Princezny / princové" },
          { id: 3, points: 16, score: 4, text: "Oříšky" },
          { id: 4, points: 14, score: 3, text: "Sudičky" },
          { id: 5, points: 7, score: 2, text: "Přání" },
          { id: 6, points: 7, score: 2, text: "Úkoly" },
        ],
      },
      {
        id: 7,
        question: "Jedna pohádková bytost ti na 24 hodin musí sloužit. Která?",
        answers: [
          { id: 1, points: 25, score: 6, text: "Džin" },
          {
            id: 2,
            points: 13,
            score: 5,
            text: "Pekelník (čert, Uriáš, Lucifer)",
          },
          { id: 3, points: 10, score: 4, text: "Drak" },
          { id: 4, points: 10, score: 4, text: "Popelka" },
          { id: 5, points: 8, score: 2, text: "Zlatá rybka" },
          { id: 6, points: 5, score: 1, text: "Dobby" },
          { id: 7, points: 5, score: 1, text: "Shrek" },
        ],
      },
      {
        id: 8,
        question: "Ale ne! Princezna...",
        answers: [
          { id: 1, points: 27, score: 6, text: "ze mlejna" },
          { id: 2, points: 11, score: 5, text: "umírá, zemřela, byla zabita" },
          { id: 3, points: 10, score: 4, text: "se zlatou hvězdou" },
          { id: 4, points: 10, score: 3, text: "zmizela" },
          { id: 5, points: 6, score: 2, text: "utekla" },
          { id: 6, points: 5, score: 1, text: "byla unesena" },
          { id: 7, points: 5, score: 1, text: "usnula" },
        ],
      },
      {
        id: 9,
        question:
          "Kdybys měl poslat svého/svou nejhoršího ex na rande s jednou pohádkovou postavou, byl/a by to…",
        answers: [
          { id: 1, points: 10, score: 6, text: "Trautenberk" },
          { id: 2, points: 7, score: 5, text: "Dorota Máchalová" },
          { id: 3, points: 6, score: 4, text: "Mrakomor" },
          { id: 4, points: 6, score: 4, text: "Rumburak" },
          { id: 5, points: 6, score: 4, text: "Závist" },
          { id: 6, points: 5, score: 1, text: "Král Kazisvět" },
          { id: 7, points: 5, score: 1, text: "Marfuša" },
        ],
      },
      {
        id: 10,
        question: "Jakou zbraní bys porazil/a Draka?",
        answers: [
          { id: 1, points: 39, score: 6, text: "Mečem" },
          { id: 2, points: 21, score: 5, text: "Palnou zbraní" },
          { id: 3, points: 9, score: 4, text: "Moudrostí, přechytračením" },
          {
            id: 4,
            points: 9,
            score: 4,
            text: "Šarmem (ochočil, kamarádil se nebo ho svedl)",
          },
          { id: 5, points: 7, score: 2, text: "Lukem / kuší" },
          { id: 6, points: 5, score: 1, text: "Oslíkem (Shrek)" },
        ],
      },
      {
        id: 11,
        question: "Který kouzelný předmět bys chtěl/a získat?",
        answers: [
          { id: 1, points: 39, score: 6, text: "Arabelin kouzelný prsten" },
          { id: 2, points: 22, score: 5, text: "Kouzelnou hůlku" },
          { id: 3, points: 13, score: 4, text: "Neviditelný plášť" },
          { id: 4, points: 9, score: 3, text: "Bezedný měšec" },
          { id: 5, points: 6, score: 2, text: "Lampu s džinem" },
        ],
      },
    ],
  },
  {
    id: 3,
    text: "3. KOLO: Silvestr",
    questions: [
      {
        id: 12,
        question:
          "To by bylo ale mrzení, kdyby někdo do mísy s punčem tajně přidal…",
        answers: [
          {
            id: 1,
            points: 32,
            score: 6,
            text: "Alkohol, líh, vodku, rum, tuzemák, absinth, alpu, zelenou",
          },
          {
            id: 2,
            points: 27,
            score: 5,
            text: "LSD, MDMA, fentanyl, piko, kokain, crack, houby, kratom, trávu",
          },
          { id: 3, points: 10, score: 4, text: "Projímadlo" },
          { id: 4, points: 6, score: 3, text: "Vodu" },
          { id: 5, points: 6, score: 3, text: "Jed, kyanid, arsen" },
          { id: 6, points: 6, score: 3, text: "Punč" },
          { id: 7, points: 5, score: 1, text: "Moč" },
          { id: 8, points: 5, score: 1, text: "Sůl" },
          { id: 9, points: 5, score: 1, text: "Rohypnol" },
        ],
      },
      {
        id: 13,
        question: "Která píseň by měla na Silvestra hrát těsně před půlnocí?",
        answers: [
          { id: 1, points: 16, score: 6, text: "The Final Countdown (Europe)" },
          { id: 2, points: 13, score: 5, text: "Česká hymna (Kde domov můj)" },
          {
            id: 3,
            points: 6,
            score: 4,
            text: "Dlouhá noc (Helena Vondráčková)",
          },
          { id: 4, points: 5, score: 3, text: "Podvod (Nedvědi)" },
          { id: 5, points: 4, score: 2, text: "Nonstop (Michal David)" },
          { id: 6, points: 4, score: 2, text: "Happy New Year (ABBA)" },
          { id: 7, points: 4, score: 2, text: "We Are the Champions (Queen)" },
        ],
      },
      {
        id: 14,
        question:
          "Hraješ flašku a lahev zrovna ukázala na tebe. Co doufáš, že nedostaneš za úkol?",
        answers: [
          { id: 1, points: 40, score: 6, text: "Svlékat se" },
          { id: 2, points: 23, score: 5, text: "S někým se líbat" },
          { id: 3, points: 12, score: 4, text: "Zpěv" },
          { id: 4, points: 9, score: 4, text: "Jít pryč / domů" },
          {
            id: 5,
            points: 5,
            score: 2,
            text: "Sexuální interakce s ostatními",
          },
        ],
      },
      {
        id: 15,
        question: "Jaké novoroční předsevzetí byste opravdu chtěli naplnit?",
        answers: [
          { id: 1, points: 35, score: 6, text: "Cvičit" },
          { id: 2, points: 26, score: 5, text: "Zhubnout" },
          { id: 3, points: 7, score: 4, text: "Žádné" },
          { id: 4, points: 7, score: 4, text: "Zlepšení finanční situace" },
          { id: 5, points: 6, score: 2, text: "Méně prokrastinovat" },
          { id: 6, points: 4, score: 1, text: "Ukončování závislostí" },
        ],
      },
      {
        id: 16,
        question:
          "BONUS: Kdo se umístil na 2. a 3. místě v anketě „Který český (ex)politik všechny přepije?“",
        answers: [
          { id: 1, points: 20, score: 6, text: "Miroslav Kalousek" },
          { id: 1, points: 3, score: 5, text: "Petr Fiala" },
          { id: 1, points: 3, score: 5, text: "Václav Havel" },
          { id: 1, points: 3, score: 5, text: "Radek Vondráček" },
        ],
      },
    ],
  },
];
